import DB from "@/common/utils/db";
/**
 * @description 获取简历详情
 */
export function getResumeDetail(id) {
  return DB({
    url: "v1/talents/" + id,
    method: "get"
  });
}